export default "__VITE_ASSET__DR8dGOd___"